import './unclejulios2/style';
import FormStructure from './unclejulios2/form_structure';

export default FormStructure;